module.exports = __webpack_public_path__ + "static/home_item_e-2ce4a4564c39b63a7d0534a96f490b85.jpg";